export enum GlobalText {
	ToggleTransciptionLabel = "DA52AF78-369B-4F1E-9581-EA2478882AA3",
}
